import { theme } from '../../../styles/theme';
export const tagStatusBaseStyles = {
    boxSizing: 'border-box',
    borderRadius: '8px',
    padding: '4px 8px',
    gap: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
    display: 'inline-flex',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 600,
    '& .n-icon': {
        marginTop: '2px'
    },
    height: '28px',
    alignItems: 'center'
};
export const tagStatusVariantStyles = {
    default: {
        color: theme.palette.common.darkGrey12,
        backgroundColor: theme.palette.common.lightGrey5,
        borderColor: theme.palette.common.darkGrey0
    },
    success: {
        color: theme.palette.common.feedbackSuccess50,
        backgroundColor: theme.palette.common.feedbackSuccess10,
        borderColor: theme.palette.common.feedbackSuccess50
    },
    info: {
        color: theme.palette.common.feedbackInfo50,
        backgroundColor: theme.palette.common.feedbackInfo10,
        borderColor: theme.palette.common.feedbackInfo50
    },
    error: {
        color: theme.palette.common.feedbackError50,
        backgroundColor: theme.palette.common.feedbackError10,
        borderColor: theme.palette.common.feedbackError50
    },
    warning: {
        color: theme.palette.common.feedbackWarning50,
        backgroundColor: theme.palette.common.feedbackWarning10,
        borderColor: theme.palette.common.feedbackWarning50
    },
    processing: {
        color: theme.palette.common.feedbackInfo50,
        backgroundColor: theme.palette.common.feedbackInfo10,
        borderColor: theme.palette.common.feedbackInfo50
    }
};
export const getTagStatusStyles = (type) => ({
    ...tagStatusBaseStyles,
    ...tagStatusVariantStyles[type]
});
//# sourceMappingURL=NTagStatus.styles.js.map